// import React, { useContext } from 'react'
// import { ShopContext } from '../Context/ShopContext'
// import { useParams } from 'react-router-dom'
// import Breadcrum from '../Components/Breadcrums/Breadcrum'
// import ProductDisplay from '../Components/ProductDisplay/ProductDisplay'
// import DescriptionBox from '../Components/DescriptionBox/DescriptionBox'
// import RelatedProducts from '../Components/RelatedProducts/RelatedProducts'
// const Product = () => {
//     const { all_product } = useContext(ShopContext)
//     const { productId } = useParams();
//     const product = all_product.find((e) => e.id === Number(productId))
//     return (
//         <div className=''>
//             <Breadcrum product={product} />
//             <ProductDisplay product={product} />
//             <DescriptionBox />
//             <RelatedProducts />
//         </div>
//     )
// }

// export default Product


import React, { useContext } from 'react'
import { ShopContext } from '../Context/ShopContext'
import { useParams } from 'react-router-dom'
import Breadcrum from '../Components/Breadcrums/Breadcrum'
import ProductDisplay from '../Components/ProductDisplay/ProductDisplay'
import DescriptionBox from '../Components/DescriptionBox/DescriptionBox'
import RelatedProducts from '../Components/RelatedProducts/RelatedProducts'

const Product = () => {
    const { all_product } = useContext(ShopContext)
    const { productId } = useParams()

    const product = all_product.find(
        (item) => item.id === Number(productId)
    )

    if (!product) {
        return (
            <h2 style={{ textAlign: 'center', marginTop: '100px' }}>
                Loading product...
            </h2>
        )
    }

    return (
        <div>
            <Breadcrum product={product} />
            <ProductDisplay product={product} />
            <DescriptionBox />
            <RelatedProducts currentProductId={product.id} />
        </div>
    )
}

export default Product
